import { NavLink, useLocation } from "react-router-dom";

type NavItem = {
  title: string;
  slug: string;
  children?: NavItem[];
};

export function Nav({
  items,
  className,
}: {
  items: NavItem[];
  className?: string;
}) {
  const location = useLocation();

  return (
    <ul className={`p-0 flex flex-row rounded-sm bg-gray-200 ${className}`}>
      {items.map((item) => (
        <li
          key={item.slug}
          className="p-0 h-[40px] border-r border-gray-300 last:border-r-0"
        >
          <NavLink
            className={`px-2 h-full flex items-center ${isActive(item.slug, location.pathname) ? "bg-gray-600 text-white" : ""}`}
            to={item.slug}
          >
            {item.title}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}

function isActive(slug: string, pathname: string): boolean {
  return pathname === slug || pathname.startsWith(`${slug}/`);
}
